<template>
  <v-container>
    <v-card class="mt-8">
      <v-data-table
        :search="search"
        :headers="lg_apikey_list.headers"
        :items="mDataArray"
        :items-per-page="7"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ lg_apikey_list.title }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="lg_apikey_list.apikey_search"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              @click="$router.push('/apikey-create')"
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon left>add</v-icon>
              <span>{{ lg_apikey_list.apikey_add }}</span>
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item="{ item }">
          <tr :class="{ primary: item.id === selectedApiKeyId }">
            <td @click="editItem(item)">{{ item.id }}</td>

            <td @click="editItem(item)">{{ item.api_key_name }}</td>
            <td style="min-width:120px;">
              <v-icon class="mr-2" @click="editItem(item)" color="green">
                edit
              </v-icon>
              <span class="ma-1"></span>
              <v-icon @click="deleteItem(item)" color="red"> delete </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog v-model="confirmDeleteDlg" width="unset">
        <v-card>
          <v-card-title class="headline">{{
            lg_apikey_list.dialog_title
          }}</v-card-title>

          <v-card-text class="body">
            {{ lg_apikey_list.dialog_delete }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="confirmDeleteDlg = false">
              {{ lg_apikey_list.dialog_cancel }}
            </v-btn>

            <v-btn color="error" text @click="confirmDelete">
              {{ lg_apikey_list.dialog_confirm }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <LoadingDialog></LoadingDialog>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/services/api";
import LoadingDialog from "../../components/cards/LoadingDialog.vue";
import { feature } from "../../services/constants";
import { lg_apikey_list } from "../language/lg_apikey";

export default {
  name: "apikey-config",
  beforeCreate() {
    if (api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login-account");
    }
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_apikey_list = lg_apikey_list.apikey_list_th)
      : (this.lg_apikey_list = lg_apikey_list.apikey_list_en);

    // console.log("lg_apikey_list: " + JSON.stringify(this.lg_apikey_list));
  },
  async mounted() {
    this.$store.state.loadMenu = true;
    this.loadApiKey();
  },
  components: {
    LoadingDialog,
  },
  data() {
    return {
      search: "",
      selectedApiKeyId: "",
      confirmDeleteDlg: false,
      mDataArray: [],
    };
  },
  methods: {
    async loadApiKey() {
      let result = await api.getAllApiKey();
      this.mDataArray = result.data;
      this.$store.state.loadMenu = false;
    },
    editItem(item) {
      this.$router.push(`/apikey-edit/${item.id}`);
      // alert(`/stock-edit/${item.id}`);
    },
    deleteItem(item) {
      this.selectedApiKeyId = item.id;
      this.confirmDeleteDlg = true;
      // alert(`/ApiKey-delete/${this.selectedApiKeyId}`);
    },
    async confirmDelete() {
      this.confirmDeleteDlg = false;
      // this.$store.state.loadMenu = true;
      const resdel = await api.deleteApiKey(this.selectedApiKeyId);
      if(resdel.status == 200 || resdel.status == 201){
       await this.loadApiKey();
      }
    },
  },
};
</script>

<style></style>
